import React, { Component } from 'react';
import classnames from 'classnames';
import './DisplayCard.scss';

class DisplayCard extends Component {
  render() {
    return (
      <div className={classnames('displayCard', this.props.className)} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

export default DisplayCard;
